<template>
  <div class="quote-tab">
    <div
      class="filter-card"
      :class="{
        'gray': !renewalStatus,
        'green': renewalStatus == 2,
        'red': renewalStatus == 3,
        'yellow':showCancel,
        'blue-dark-bg':isForeverFree
      }">
      <div
        class="filter-top flex-sb-center"
      >
        <div class="search-box">
          <span>Membership Status:
            <span
              :class="{
                'gray-color': !renewalStatus,
                'green-color': renewalStatus == 2,
                'red-color': renewalStatus == 3,
                'yellow-color':showCancel,
                'blue-dark-bg':isForeverFree
              }">
              <span v-if="!renewalStatus||renewalStatus==3">Inactive</span>
              <template v-else>
                <template v-if="!isFina">
                  <span>{{renewalStatus==2?'Active':'Expired'}} </span>
                  <span v-if="renewalStatus==3">{{renewal.expired_at}}</span>
                </template>
                <template v-else>
                  <span
                    v-if="isForeverFree"
                    class="blue-dark">
                    (Free Account)
                  </span>
                  <span v-if="renewalStatus==2&&!isForeverFree" >({{renewal.renewal_type==1?'Monthly':'Annually'}})</span>
                  <p
                    v-if="(renewalStatus==2&&autoRenew)&&renewal.expired_at"
                    class="fs-14 mg-t-10 fw-400 color-dark">Next Auto Paid {{renewal.expired_at}}</p>
                  <p
                    v-if="(showCancel||renewalStatus==3)&&renewal.expired_at"
                    class="fs-14 mg-t-10 fw-400 color-dark">Expiry Date {{renewal.expired_at}}</p>
                </template>

              </template>
            </span>
          </span>
        </div>
        <div class="btn-group">
          <v-button
            v-if="isNotTeamGroup&&!isFina"
            @click="showJoinTeam">
            Join Team
          </v-button>
          <v-button
            v-if="customer_profile.team_head_url&&is_tier_base"
            gray
            icon="qrcode"
            @click="showQrcCode">Team Code</v-button>
          <v-button
            v-if="!is_tier_base"
            gray
            @click="handleSubscribe">
            <!--            Subscribe-->
            Upgrade (Free Pro Account)
          </v-button>

          <!--          <v-button-->
          <!--            v-if="showCancelBtn&&!isFina"-->
          <!--            size="small"-->
          <!--            @click="clickDetail">-->
          <!--            <section class="detail">-->
          <!--              &lt;!&ndash;              <font-awesome-icon&ndash;&gt;-->
          <!--              &lt;!&ndash;                icon="fa-brands fa-stripe"&ndash;&gt;-->
          <!--              &lt;!&ndash;                class="icon"/>&ndash;&gt;-->
          <!--              <span class="name">Downgrade</span>-->
          <!--            </section>-->
          <!--          </v-button>-->
          <v-button
            v-if="showSMSEmail"
            size="small"
            icon="sms"
            class="btn"
            @click="clickSms"></v-button>
          <v-button
            v-if="showSMSEmail"
            size="small"
            icon="envelope"
            class="btn"
            @click="clickEmail"></v-button>
          <v-button
            v-if="showCancelBtn"
            red
            @click="showCancelPopup = true"
          >Unsubscribed
          </v-button>
          <v-button
            v-if="!isForeverFree&&isFina&&is_tier_base"
            red
            @click="handleChangeStatus"
          >Change Status
          </v-button>
        </div>
      </div>
    </div>
    <section
      v-if="renewal.status==2"
      class="sme-container__info">
      <div class="box">
        <div class="table">
          <div class="th font-14" >
            <span class="flex-sb-center">
              <span>Pro Account</span>
              <span
                v-if="renewalStatus==2&&!isFina"
                class="pointer blue"
                @click="handleOpenPro">Change Pro/Pro Plus</span>
            </span>
          </div>
          <div class="form-item tr">
            <span>Account Type</span>
            <span>{{renewal.vip_level==1?'Pro Plus':'Pro'}} {{renewal.is_special_pro==1?'(Custom Referrer Discount)':''}}</span>
          </div>
          <div class="form-item tr">
            <span>Referred By</span>
            <span
              :class="{'blue border-0 pointer':!!referred_by.name}"
              @click="handleAccount(referred_by.user_id)">{{referred_by.name||'-'}}</span>
          </div>
          <div class="form-item tr">
            <span>Upgrade Date</span>
            <span>{{renewal.upgrade_date}}</span>
          </div>
        </div>
      </div>
    </section>
    <section
      v-if="!isNotTeamGroup&&!isFina"
      class="sme-container__info">
      <div class="box">
        <div class="table">
          <div class="th font-14" >Current Team</div>
          <div class="form-item tr ">
            <span>Team Name</span>
            <span
              class="blue  border-0 pointer"
              @click="handleTeamDetail(team_group.team_group_id)">{{team_group.team_name||'-'}}</span>
          </div>
          <div class="form-item tr">
            <span>Team Level</span>
            <span>{{team_group.team_level}}</span>
          </div>
          <div class="form-item tr">
            <span>Team Size</span>
            <span>{{team_group.team_size}}</span>
          </div>
          <div class="form-item tr">
            <span>Joinning Date</span>
            <span>{{team_group.join_at}}</span>
          </div>
        </div>
      </div>
    </section>

    <template v-if="isFina">
      <div class="transparent">
        <el-table
          :data="tableData"
          style="width: 100%"
          :row-class-name="'table-pointer'"
          :header-row-class-name="'tableHeader'"
        >
          <el-table-column
            width="10px"
            align="center">
          </el-table-column>
          <el-table-column
            prop="number"
            label="Invoices">
            <template #default="{ row }">
              <div class="flex-algin">
                <span>{{ row.date }}</span><br>
              </div>
            </template>
          </el-table-column>
          <el-table-column
          >
            <template #default="{ row }">
              <span class="span-label">{{ row.number }}</span>
            </template>
          </el-table-column>
          <el-table-column
          >
            <template #default="{ row }">
              <span class="span-label">{{ row.amount | formatMoney(2, true)  }}</span><br>
            </template>
          </el-table-column>
          <el-table-column>
            <template #default="{ row }">
              <span
                class="span-options"
                :class="{
                  'red':row.status != 'paid' ,
                  'green': row.status == 'paid'
                }">
                {{ row.status }}
              </span>
            </template>
          </el-table-column>
          <el-table-column
          >
            <template #default="{ row }" >
              <a
                v-if="row.url"
                :href="row.url"
                target="_blank"
                class="span-label text-decoration-none blue">Invoice</a>
            </template>
          </el-table-column>

        </el-table>
      </div>
      <v-pagination
        :total="pageConfig.total"
        :current="pageConfig.currentPage"
        @currentChange="currentChange" />
    </template>
    <member-cancel
      v-model="showCancelPopup"
      :expired-time="renewal.expired_at"
      :autoRenew="autoRenew"
      @continue="handleCancel"
    ></member-cancel>

    <send-email-sms
      ref="send-email-sms"
      :form="form.customer_profile"
      :initContent="memberShip.diamond_member_data"
      :emailListTitle="memberShip.diamond_member_list_title"
      :emailTitle="memberShip.diamond_member_title"
      :skip="false"
      :type="emailSmsType"
      @send="handlerSend"  />
    <send-email-sms
      ref="send-email-sms-cancel"
      :form="form.customer_profile"
      :initContent="initContent"
      :emailListTitle="emailListTitle"
      :emailTitle="emailTitle"
      @skip="handlerCancelSkip"
      @send="handlerCancelSend"  />
    <join-team-dialog
      v-model="showTeam"
      :customer-id="customerId"
      @update="handleUpdate"></join-team-dialog>
    <qr-code
      v-model="showCode"
      is-member
      :form="customer_profile"></qr-code>
    <change-pro
      v-model="showPro"
      :level-id="customer_profile.vip_level"
      :is-special-pro="renewal.is_special_pro"
      @update="handleUpdate"></change-pro>
  </div>
</template>

<script>
import MixinOptions from '@/mixins/options'
import {getReferralInfo, getReferralInvoices, referralCancel, sendMess,chargeReferrerStatus} from '@/api/referral'
import MixinFormat from '@/mixins/format'
import memberCancel from '@/views/accounts/components/popup/memberCancel'
import SendEmailSms from '@/views/components/dialogs/send-email-sms'
import QrCode from './popup/referral-qr-code'
import JoinTeamDialog from '@/views/records/referrerReward/team/component/join-team-dialog'
import ChangePro from '@/views/accounts/components/popup/change-pro'

export default {
  name: 'memberShip',
  components:{
    ChangePro,
    memberCancel,
    SendEmailSms,
    QrCode,
    JoinTeamDialog,
  },
  mixins: [MixinOptions,MixinFormat],
  props: {
    customerId: [String, Number],
    form: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      showCode:false,
      showTeam:false,
      showPro:false,
      pageConfig: {
        //  分頁配置
        currentPage: 1,
        total: 10
      },
      tableData: [],
      renewal:{},
      showCancelPopup:false,
      emailSmsType: 1,
      cancel_type:1
    }
  },
  computed: {
    isFina(){
      let {customer_profile} = this.form||{}
      let {account_type} = customer_profile||{}
      return account_type == 2
    },
    referred_by(){
      let {referred_by} = this.renewal||{}
      return referred_by||{}
    },
    showCancel(){
      return this.renewal.status == 2 && !this.renewal.auto_renew
    },
    showCancelBtn(){
      return this.renewal.status == 2
    },
    isForeverFree(){
      return this.renewal.forever_free == 1
    },
    renewalStatus(){
      return this.renewal.status
    },
    autoRenew(){
      return this.renewal.auto_renew
    },
    showDetail(){
      return this.showCancel || this.renewalStatus == 2 || this.renewalStatus == 3
    },
    showSMSEmail(){
      return !this.renewalStatus || this.renewalStatus == 3
    },
    memberShip(){
      return this.form.membership||{}
    },
    is_tier_base(){
      let {is_tier_base=false} = this.form.customer_profile
      return is_tier_base
    },
    emailListTitle(){
      let {diamond_account_downgraded_list_title}  = this.form||{}
      return diamond_account_downgraded_list_title
    },
    emailTitle(){
      let {diamond_account_downgraded_title}  = this.form||{}
      return diamond_account_downgraded_title
    },
    initContent(){
      let {now_diamond_account_downgraded_data}  = this.form||{}
      return now_diamond_account_downgraded_data
    },
    customer_profile(){
      let {customer_profile}  = this.form||{}
      return customer_profile||{}
    },
    team_group(){
      let {team_group} = this.renewal||{}
      return team_group||{}
    },
    isNotTeamGroup(){
      let {team_group_id} = this.team_group
      return !team_group_id
    }
  },
  async mounted() {
    await this.network().getReferralInfo()
    await this.network().getReferralInvoices()
  },
  methods: {
    handleOpenPro(){
      this.showPro = true
    },
    handleTeamDetail(team_id){
      this.$router.push(`/records/team/detail/${team_id}`)
    },
    async handleUpdate(){
      await this.network().getReferralInfo()
      await this.network().getReferralInvoices()
    },
    handleChangeStatus(){
      this.$ConfirmBox({
        isNewConfirm:true,
        width:500,
        title:'Membership Status',
        confirmBtn:'Confirm',
        isRed:true,
        message: 'Upgrade this account to Free Pro ?'
      }).then(async () => {
        await this.network().chargeReferrerStatus()
        await this.network().getReferralInfo()
      })
    },
    handleAccount(id){
      if(!id)
        return
      this.$router.push({
        path:'/accounts/detail',
        query:{customer_id:id}
      })
    },
    showQrcCode(){
      this.showCode = true
    },
    showJoinTeam(){
      this.showTeam = true
    },
    handlerCancelSkip(){
      let params ={
        is_send:0,
        content:''
      }
      this.network().referralCancel(params)
    },
    handlerCancelSend(content){
      let params ={
        content:content,
        is_send:1
      }
      this.network().referralCancel(params)
    },
    routerToPolicy({ id, pcy_id, product_id = -1 }) {

    },
    currentChange(page) {
      this.pageConfig.currentPage = page
      // this.network().getReferralList()
    },
    handleCancel(cancel_type){
      this.cancel_type  = cancel_type
      this.$refs['send-email-sms-cancel'].changeDialog()
    },

    clickDetail(){
      this.$ConfirmBox({
        isNewConfirm:true,
        width:500,
        title:'Downgrade Membership',
        confirmBtn:'Downgrade',
        // isGreen:true,
        message: 'When do you want to downgrade this customer’s membership?'
      }).then(() => {
        this.$refs['send-email-sms-cancel'].changeDialog()
      })
      // window.open(this.memberShip.stripe_detail_url, '_blank')
    },
    clickSms(){
      this.emailSmsType = 1
      this.$refs['send-email-sms'].changeDialog()
    },
    clickEmail(){
      this.emailSmsType = 2
      this.$refs['send-email-sms'].changeDialog()
    },
    handlerSend(content){
      let params = {
        send_typ: this.emailSmsType,
        customer_id: this.customerId,
        content,
      }
      this.network().sendMess(params)
    },
    handleSubscribe(){
      this.$parent.$parent.showSubscribe = true
    },
    network() {
      return {
        chargeReferrerStatus: async () => {
          const { data } = await chargeReferrerStatus({
            user_id: this.customerId,
          })
          this.$emit('update')
        },
        getReferralInfo: async () => {
          const { data } = await getReferralInfo({
            user_id: this.customerId,
          })
          this.renewal = data
          this.$emit('update')
        },
        getReferralInvoices: async () => {
          const { data } = await getReferralInvoices({
            page: this.pageConfig.currentPage,
            user_id: this.customerId,
          })
          if(data){
            this.tableData = data
          }
          // this.pageConfig.total = data.total
        },
        referralCancel: async (params) => {
          const { data } = await referralCancel({
            user_id: this.customerId,
            cancel_type:this.cancel_type,
            is_send:this.is_send,
            ...params
          })
          this.showCancelPopup = false
          this.$emit('update')
          this.network().getReferralInfo()
        },
        sendMess: async (params) => {
          const {data} = await sendMess(params)
          // this.$refs['send-email-sms'].changeDialog()
          if(data.code == 1000){
            this.$message({
              type: 'success',
              message: 'Success'
            })
          }
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
@import "../../quoting/sme/info";
.quote-tab {
  position: relative;

  h1 {
    padding-bottom: 15px;
    color: #616266;
    font-size: 20px;
  }
  .filter-card{
    padding: 15px;
    border: 1px solid #E1E4E8;
    border-radius: 5px;
    margin-bottom: 20px;
    &.green {
      background: #DCFFE4;
      color: #000;
      border: 1px solid rgba(23, 111, 44, 0.2);
      .green-color{
        color: #22863A;
      }
    }
    &.yellow{
      background: #FFFBDD;
      border: 1px solid rgba(176, 136, 0, 0.2)
    }
    &.red {
      color: #000;
      background: #FFE3E6;
      /* Flash/Red Border */
      border: 1px solid rgba(158, 28, 35, 0.2);
      .red-color{
        color: #D73A49;
      }
    }
    &.gray {
      color: #000;
      background: #F6F8FA;
      border: 1px solid #D1D5DA;
      .gray-color{
        color: #586069;
      }
    }
    &.blue-dark-bg{
      background: rgb(216,234,237);
      border: 1px solid rgb(200,228,230);
    }
    .search-box {
      //margin-right: 20px;
      width: 100%;
      flex: 1;
      font-weight: 600;
      font-size: 14px;
    }
  }
  .span-name {
    display: block;
    color: #24292E;
  }

  .span-label {
    display: block;
    color: #24292E;
    font-weight: 500;
    height: 20px;
    line-height: 20px;
    &.blue{
      color: $blue;
      text-decoration: none!important;
    }
  }
  .form-half {
    & > span {
      display: block;
      padding-bottom: 5px;
      font-size: 14px;
      color: #6a737d;
    }
  }
  .span-status, .span-options {
    display: inline-block;
    //margin-right: 15px;
    padding: 1px 8px;
    font-weight: 600;
    font-size: 12px;
    line-height: 18px;
    color: #FFFFFF;
    border-radius: 100px;
    //text-overflow: ellipsis;
    //width: 120px;
    max-width: 140px;
    word-break: keep-all;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;

    .svg-inline--fa {
      margin-right: 5px;
      font-size: 14px;
    }
  }
  .span-options{
    border: 1px solid;
    &.gray {
      border-color: #586069;
      color: #586069;
    }
    &.green {
      border-color: #22863A;
      color: #22863A;
    }
    &.red {
      border-color: #D73A49;
      color: #D73A49;
    }
    &.gold {
      border-color: #735C0F;
      color: #735C0F;
    }
    &.blue {
      border-color: #0366D6;
      color: #0366D6;
    }
    &.orange {
      border-color: #C24E00;
      color: #C24E00;
    }
    &.black {
      border-color: #24292E;
      color: #24292E;
    }
  }
  .icon-color{
    &.gray {
      color: #586069;
    }
    &.green {
      color: #22863A;
    }
    &.red {
      color: #D73A49;
    }
  }
  .filter-top-select{
    margin-bottom: 15px;
    border-bottom: 1px solid #E1E4E8;
    //padding-bottom: 16px;
    display: flex;
    span{
      padding: 16px 10px;
      font-family: 'Inter';
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      color: #586069;
      display: block;
      &.is_active{
        color: #24292E;
        border: 1px solid #E1E4E8;
        border-bottom: 0;
        background: #fff;
        padding-bottom: 1px;
        margin-bottom: -1px;
        border-top-left-radius: 5px;
        border-top-right-radius: 5px;
      }
      &:first-child{
        margin-left: 10px;
      }
    }
  }
  .circle {
    display: inline-block;
    margin-right: 5px;
    width: 14px;
    height: 14px;
    min-width: 14px;
    min-height: 14px;
    border-radius: 100%;
    &.orange-light {
      background: #E36209;
    }
    &.yellow-dark {
      background: #DBAB09;
    }
    &.blue {
      background: #0366D6;
    }
    &.green {
      background: #28A745;
    }
    &.red {
      background: #D73A49;
    }
  }
  .purple {
    background: #6F42C1;
  }
  ::v-deep .el-table{
    .table-pointer{
      cursor: pointer;
    }
  }
  ::v-deep .el-table{
    border-radius: 4px;
    border: 1px solid #E1E4E8;
    tr{
      td{
        //display: flex;
        vertical-align: top;
        margin-right: 15px;
        height: 40px;
        padding: 0 !important;
        .cell{
          //min-height: 40px;
          line-height: 23px;
          position: relative;
          height: inherit;
          //margin-left: 10px;
          //margin-right: 10px;
          padding: 10px 5px;
          //padding: 5px 10px;
          //position: absolute;
          //top: 10px;
        }
      }
    }
  }
  .flex-algin {
    /*display: flex;*/
    /*flex-direction: column;*/
    //justify-content: space-between;
    //font-weight: 500;
    height: 20px;
    line-height: 20px;
    vertical-align: middle;
    &.time-text{
      font-size: 12px;
    }
    .icon-text{
      font-weight: 600;
      font-size: 14px;
      line-height: 20px;
      display: flex;
      align-items: center;
      letter-spacing: -0.15px;
      color: #24292E;
      margin-left: 15px;
    }
    .phone-text{
      font-size: 12px;
      color: #6A737D;
      .weight-text{
        font-weight: 600;
      }
    }
    &.period-text{
      span{
        font-size: 12px;
      }
    }
    p, span {
      min-height: 20px;
    }
    .first-text{
      color: #24292E;
      font-size: 14px;
    }
    .summary{
      font-size: 12px;
      word-break: break-word;
    }
    .status-height{
      height: 23px;
    }
  }
  .table-icon{
    &.margin-top-flex{
      margin-top: 5px;
    }
    .icon{
      margin-right: 10px;
      img{
        height: 22px;
        width: 22px;
      }
    }
    .icon-content{
      height: 22px;
      width: 22px;
      border-radius: 5px;
      background-color: #E1E4E8;
      color: #6A737D;
      font-size: 14px;
      text-align: center;
      line-height: 22px;
      display: flex;
      justify-content: center;
      align-items: center;
      border: 1px solid #e1e4e8;
    }
    .backgroud-width{
      background: #fff!important;
      border: 1px solid #e1e4e8;
    }
  }
  ::v-deep .tableHeader {
    margin-top: 30px;
    background: #F6F8FA !important;
    border-bottom: 1px solid #E1E4E8;

    th {
      background-color: #F6F8FA !important;
      font-family: Inter;
      font-style: normal;
      font-weight: 600;
      font-size: 14px;
      letter-spacing: -0.15px;
      /* Text/text-gray-dark */
      padding: 10px 0!important;
      color: #24292E!important;
      .cell{
        padding-left: 0;
      }
    }
    .button-border{
      display: inline-block;
      padding: 0px 10px;
      height: auto;
      //line-height: 30px;
      font-size: 12px;
      border-radius: 50px;
      border: 1px solid #E1E4E8;
      color: #24292E;
      background: white;
      font-weight: 500;
      letter-spacing: 0;
      line-height: 18px;

    }
  }
}
.btn-group{
  display: flex;
  .el-button{
    background: #FAFBFC;
    border: 1px solid rgba(27, 31, 35, 0.15);
    box-shadow: 0px 1px 0px rgba(27, 31, 35, 0.04);
    border-radius: 6px;
    font-weight: 600;
    font-size: 14px;
    font-family: inter;
  }
  .detail{
    display: flex;
    align-items: center;
    .icon{
      font-weight: 400;
      margin-right: 3px;
      font-size: 14px;
      color: #586069;
    }
    .name{
      font-weight: 600;
      color: #24292E;
    }
  }
  .btn{
    /deep/ .btn-label{
      margin: 0 !important;
    }
  }
  .red{
    color: #CB2431;
  }
}
.sme-container__info .table .tr span:nth-child(2) {
  &.blue{
    color: #0366D6!important;
  }
}
.blue-dark{
  color: rgb(68,145,166);
}
.blue-dark-bg{
  background: rgb(216,234,237);
}
.border-0{
  border: 0!important;
}

</style>
